<div class="view-container">
    <form [formGroup]="dynamicForm" (ngSubmit)="submitted.emit(dynamicForm.value)">

        <ng-container class="view-container"  *ngFor="let col of getRowTemplate('PK')" #viewContainer dynamicField [config]="col" [group]="dynamicForm"  [arrayColumnsDef]="arrayColumnsDef" >
        </ng-container>

        <nz-tabs [(nzSelectedIndex)]="selectedTabIndex" (nzSelectedIndexChange)="refreshChild($event)">
            <nz-tab nzTitle="Geral">
                    <ng-container class="view-container-tab"  *ngFor="let col of rowTemplate" #viewContainer dynamicField [config]="col" [group]="dynamicForm"  [arrayColumnsDef]="arrayColumnsDef" >
                    </ng-container>
            </nz-tab>

            <nz-tab *ngFor="let tab of tabs; let index = index" [nzTitle]="$any(tab)">
                <ng-template nz-tab>
                    <app-dynamic-forms
                            #childform
                            inputEntityName='{{tab | capitalize}}'
                            inputTableName='{{tab | capitalize}}'
                            [child]="true"
                            [fatherFilterExpression]="fatherFilterExpression"
                            [fatherdata]="fatherData"
                            [filterExpression]="dynaServices.childFilterExpression=='' ? dynaServices.filterExpression : dynaServices.childFilterExpression"
                            >
                    </app-dynamic-forms>
                </ng-template>
            </nz-tab>
        </nz-tabs>

    </form>
    <ng-template #dynamic></ng-template>
</div>
